import type { ComponentType, ReactNode } from "react";

/**
 * Combines React components into a single composite component.
 *
 * This function takes an array of React components and composes them into a single component.
 * The components are applied sequentially, wrapping each subsequent component around the previous one.
 *
 * @param components - An array of React components to be combined.
 *
 * @returns A composite React component.
 */
export const combineComponents = (
    ...components: ComponentType<{ children?: ReactNode }>[]
): ComponentType<{ children?: ReactNode }> => {
    return components.reduce(
        (AccumulatedComponents, CurrentComponent) => {
            return ({ children }: { children?: ReactNode }) => {
                return (
                    <AccumulatedComponents>
                        <CurrentComponent>{children}</CurrentComponent>
                    </AccumulatedComponents>
                );
            };
        },
        ({ children }: { children?: ReactNode }) => <>{children}</>,
    );
};
